/**
 * GA4 event tracking utility for Oscilabs.
 * Wraps window.gtag() — components never call it directly.
 * On localhost, events log to console.debug instead of sending to GA.
 */

const IS_PROD = window.location.hostname !== 'localhost';

function trackEvent(eventName, params = {}) {
  if (!IS_PROD) {
    console.debug('[GA4]', eventName, params);
    return;
  }
  if (typeof window.gtag === 'function') {
    window.gtag('event', eventName, params);
  }
}

// ─── HIGH PRIORITY ───────────────────────────────────────

export function trackContactFormSubmit({ facilityType, numSites, interest }) {
  trackEvent('contact_form_submit', {
    facility_type: facilityType,
    num_sites: numSites,
    interest,
  });
}

export function trackHeroCTAClick(label) {
  trackEvent('hero_cta_click', { cta_label: label });
}

export function trackProductCTAClick(productName) {
  trackEvent('product_cta_click', { product: productName });
}

// ─── MEDIUM PRIORITY ─────────────────────────────────────

export function trackDeploymentOptionClick(optionTitle) {
  trackEvent('deployment_option_click', { option: optionTitle });
}

export function trackNavCTAClick() {
  trackEvent('nav_cta_click', { cta_label: 'get_started' });
}

export function trackFAQToggle(questionText) {
  trackEvent('faq_toggle', { question: questionText });
}

export function trackDashboardLinkClick() {
  trackEvent('dashboard_link_click', { destination: 'site.charitysense.com' });
}

// ─── LOW PRIORITY ────────────────────────────────────────

export function trackNavSectionClick(sectionId) {
  trackEvent('nav_section_click', { section: sectionId });
}

export function trackCarouselNavigate(sceneIndex, sceneLabel) {
  trackEvent('carousel_navigate', {
    scene_index: sceneIndex,
    scene_label: sceneLabel,
  });
}

export function trackMobileMenuToggle(isOpening) {
  trackEvent('mobile_menu_toggle', { action: isOpening ? 'open' : 'close' });
}

export function trackEmailClick() {
  trackEvent('email_click', { destination: 'contact@oscilabs.com' });
}
